import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { GatewayService } from 'projects/core/src/lib/core/GatewayService';
import { MessageService } from 'projects/core/src/lib/core/MessageService';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { IncompleteFormComponent } from './components/incomplete-form/incomplete-form.component';
import { QuestionComponent } from './components/question/question.component';
import { QuestionModel } from './model/QuestionModel';

enum StepScreen {
  IncompleteForm,
  Question
}

@Component({
  selector: 'lib-client-prospect',
  templateUrl: './client-prospect.component.html',
  styleUrls: ['./client-prospect.component.scss']
})
export class ClientProspectComponent implements OnInit, OnDestroy {

  @ViewChild('componentQuestion') componentQuestion: QuestionComponent
  @ViewChild('componentIncompleteForm') componentIncompleteForm: IncompleteFormComponent
  @ViewChild('boxQuestion') boxQuestion

  @Input() nomeAcessor: String;

  question: QuestionModel  = new QuestionModel()
  gatewayService = new GatewayService()
  currentStep = StepScreen.IncompleteForm
  client = null
  showConfirmQuestion = true
  showBackQuestion = false
  showCompleteForm = false
  isFirstLoading = true
  showViewLoading = false

  constructor(
    public router: Router,
    private loadingController: LoadingController
  ) { }

  async ngOnInit(): Promise<void> {
    this.initObservable()
    this.handlerInitFormQuestion()
  }

  ngOnDestroy(): void {
    MessageService.clearMessages()
  }

  initObservable() {
    MessageService.getMessage().subscribe(message => {
      if (message && message.identifyObservable == MessageService.KEY_CLIENT_PROSPECT_SELECT_USER_INCOMPLETE_FORM) {
        this.currentStep = StepScreen.Question
        this.client = message.message
        this.handlerInitFormQuestion()
      } else if (message && message.identifyObservable == MessageService.KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION) {
        this.btnConfirmAnswer()
      } else if (message && message.identifyObservable == MessageService.KEY_CLIENT_PROSPECT_CONFIRM_LAST_QUESTION) {
        this.confirmFinish()
      }
    })
  }

  handlerInitFormQuestion() {
    if (this.currentStep == StepScreen.Question) {
      this.getQuestion()
    }
  }

  async getQuestion() {
    const loading = await this.showLoading()
    try {
      const result = await this.gatewayService.requestGet(`/api/partners/wise/form/${this.client.client_id}/question`)

      this.handlerResultQuestion(result)
    } catch(e: any) {
      alert(e.message)
    }
    loading.dismiss()
  }

  handlerShowConfirmButton(type) {
    this.showConfirmQuestion = true
    switch (type) {
      case "options":
      case "string":
      case "ml_string":
      case "boolean": {
        this.showConfirmQuestion = false
      } break;
    }
  }

  handlerShowBackQuestion(id) {
    this.showBackQuestion = true
    if (id == 1) {
      this.showBackQuestion = false
    }
  }

  scroolToBottom() {
    let el = document.getElementById("boxRoot")
    let elBoxQuestion = document.getElementById("boxQuestion") as any
    if (elBoxQuestion) {
      let offsetTop = el.offsetHeight
      setTimeout(() => {
        elBoxQuestion.scrollTo(0, offsetTop)
      }, 150)
    }
  }

  btnClickBack() {
    this.showCompleteForm = false
    this.currentStep = StepScreen.IncompleteForm
  }

  async btnClickFinish() {
    let isWeb = await AppStorage.get(AppSession.CHAVE_IS_WEB)
    if (isWeb == true) {
      this.currentStep = StepScreen.IncompleteForm
    } else {
      this.router.navigate([""])
    }
  }

  async btnPreviusQuestion() {
    const loading = await this.showLoading()
    try {
      const position = this.question.id as number > 0 ? this.question.id as number - 1 : 0;
      const result = await this.gatewayService.requestGet(`/api/partners/wise/form/${this.client.client_id}/question/${position}`)

      this.handlerResultQuestion(result)
    } catch(e: any) {
      alert(e.message)
    }
    loading.dismiss()
  }

  async handlerResultQuestion(result) {
    if (result.status == 200) {
      this.question = result.data
      this.handlerShowBackQuestion(this.question.id)
      this.handlerShowConfirmButton(this.question.type)
      this.scroolToBottom()
      if (this.componentQuestion) this.componentQuestion.handlerSetFocusInput(this.question.type)
    } else if (result.status == 204) {
      // questão fake para exibir IPCA/CDI no final do formulário
      let ipca = "-"
      let cdi = "-"
      try {
        const result = await this.gatewayService.requestGet(`/api/partners/wise/form/indicators`)
        if (result.status == 200) {
          ipca = result.data.find(element => element.name == "IPCA")?.value_str || "-"
          cdi = result.data.find(element => element.name == "CDI")?.value_str || "-"
        }
      } catch(e) {

      }
      
      this.question = {
        "category": "Indicadores",
        "extras": `Indicadores IPCA e CDI acumulados dos últimos 12 meses<br><br><strong>IPCA: ${ipca} e CDI: ${cdi}</strong>`,
        "question": "IPCA/CDI",
        "type": "last_question"
      } as any
      this.showBackQuestion = false
    } else {
      throw Error(ThrowError.MESSAGE_DEFAULT)
    }
  }

  confirmFinish() {
    this.showCompleteForm = true
  }

  async showLoading() {
    const loading = await this.loadingController.create({
      duration: 0,
      mode: 'ios',
      keyboardClose: true
    });
    await loading.present();
    return loading
  }

  async btnConfirmAnswer() {
    this.showViewLoading = true
    try {
      const body = {
        pergunta_id: this.question.id,
        answer: this.componentQuestion.getAnswer()
      }
      
      const result = await this.gatewayService.requestPost(`/api/partners/wise/form/${this.client.client_id}/answer`, body)
      this.handlerResultQuestion(result)

      if (body.pergunta_id == 1) {
        this.client.name = body.answer
      }

    } catch(e: any) {
      alert(e.message)
    }
    this.showViewLoading = false
  }
}
